module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo01-7da89664813285be669d6ef6bdd4f30f.jpg";